module.exports = __webpack_public_path__ + "acb55d5093598d06e3fcafd3c8bb973d.MP3";